'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAccessibleAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import { getNetworkFromParams } from 'AdsUI/selectors/PropsSelectors';
import { getCampaignRequestStatus, getCampaignForCampaignDetails } from 'AdsUI/selectors/CampaignReportingSelectors';
import { fetchCampaignDetails } from 'AdsUI/actions/CampaignReportingActions';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import makeLoadable from 'AdsUI/lib/makeLoadable';
import { EntityTypes } from 'AdsUI/lib/Constants';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';
import FailedEntityManagementPanel from 'AdsUI/components/campaign-reporting/FailedEntityManagementPanel';
const EntityManagementPanelContainerLoader = makeLoadable(() => import('./EntityManagementPanelContainer'));

const CampaignListManagementPanelContainer = ({
  adAccounts,
  match: {
    params: {
      accountId,
      campaignId
    }
  },
  globalFilters,
  network,
  campaignRequestStatus,
  campaignDetails,
  history,
  location,
  dispatch
}) => {
  const adAccount = adAccounts.find(account => account.network === network && account.accountId === accountId);
  const [shouldReloadCampaign, setShouldReloadCampaign] = useState(false);
  useEffect(() => {
    const {
      timeRange,
      attributionView,
      initialized
    } = globalFilters;

    if (adAccount && initialized) {
      if (shouldReloadCampaign || !campaignRequestStatus.fetched && !campaignRequestStatus.fetching) {
        dispatch(fetchCampaignDetails(network, accountId, campaignId, timeRange, attributionView));
        setShouldReloadCampaign(false);
      }
    }
  }, [adAccount, globalFilters, network, accountId, campaignId, dispatch, campaignRequestStatus, shouldReloadCampaign]);
  const onClose = useCallback(() => {
    history.push({
      pathname: '/',
      query: new URLSearchParams(location.search)
    });
  }, [history, location]);

  if (!campaignRequestStatus.fetched) {
    return /*#__PURE__*/_jsx(UILoadingOverlay, {});
  }

  if (campaignRequestStatus.fetchFailed) {
    return /*#__PURE__*/_jsx(FailedEntityManagementPanel, {
      entityType: EntityTypes.CAMPAIGN,
      network: network,
      onClose: onClose
    });
  }

  return /*#__PURE__*/_jsx(EntityManagementPanelContainerLoader, {
    entityType: EntityTypes.CAMPAIGN,
    entity: campaignDetails.entity,
    campaignEntity: campaignDetails.entity,
    network: network,
    adAccount: adAccount,
    onClose: onClose,
    setShouldReloadCampaign: setShouldReloadCampaign
  });
};

export default connect((state, props) => ({
  adAccounts: getAccessibleAdAccounts(state),
  network: getNetworkFromParams(state, props),
  globalFilters: getGlobalFilters(state),
  campaignRequestStatus: getCampaignRequestStatus(state, props),
  campaignDetails: getCampaignForCampaignDetails(state, props)
}))(CampaignListManagementPanelContainer);